import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/txauth_api.proto" (package "grpc.txauth", syntax proto3)
// tslint:disable
import { TxAuthApi } from "./txauth_api_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service grpc.txauth.TxAuthApi
 */

export var TxAuthApiClient = /*#__PURE__*/function () {
  function TxAuthApiClient(_transport) {
    _classCallCheck(this, TxAuthApiClient);

    this._transport = _transport;
    this.typeName = TxAuthApi.typeName;
    this.methods = TxAuthApi.methods;
    this.options = TxAuthApi.options;
  }
  /**
   *
   * POST /grpc-json/txauth/v3/auth/{provider}/{login}
   *
   * В теле запроса передаются:
   * - string password
   * - Device device
   *
   * Пример:
   *
   * POST /grpc-json/txauth/v3/auth/J2T/aivanov
   * {
   * "password": "Password1!",
   * "device": {
   * "local_id": "Valeroid",
   * "name": "DeviceName",
   * "info": {
   * "0": "platform"
   * }
   * }
   * }
   *
   * @generated from protobuf rpc: Auth(grpc.txauth.AuthRequest) returns (grpc.txauth.TokenResponse);
   */


  _createClass(TxAuthApiClient, [{
    key: "auth",
    value: function auth(input, options) {
      var method = this.methods[0],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     * POST /grpc-json/txauth/v3/renew
     *
     * В теле запроса передаются:
     * - string token
     * - Device device
     * - string code
     * - bool force
     *
     * @generated from protobuf rpc: Renew(grpc.txauth.RenewRequest) returns (grpc.txauth.TokenResponse);
     */

  }, {
    key: "renew",
    value: function renew(input, options) {
      var method = this.methods[1],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     * POST /grpc-json/txauth/v3/getloggeddevices
     *
     * @generated from protobuf rpc: GetLoggedDevices(grpc.txauth.LoggedDevicesRequest) returns (stream grpc.txauth.LoggedDevicesResponse);
     */

  }, {
    key: "getLoggedDevices",
    value: function getLoggedDevices(input, options) {
      var method = this.methods[2],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("serverStreaming", this._transport, method, opt, input);
    }
    /**
     *
     * DELETE /grpc-json/txauth/v3/logoutdevice/{key_id}
     *
     * @generated from protobuf rpc: LogoutDevice(grpc.txauth.LogoutDeviceRequest) returns (grpc.txauth.LogoutDeviceResponse);
     */

  }, {
    key: "logoutDevice",
    value: function logoutDevice(input, options) {
      var method = this.methods[3],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     * GET /grpc-json/txauth/v3/providers
     *
     * @generated from protobuf rpc: Providers(grpc.txauth.AuthProvidersRequest) returns (grpc.txauth.AuthProvidersResponse);
     */

  }, {
    key: "providers",
    value: function providers(input, options) {
      var method = this.methods[4],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * *
     *  Deprecated.
     *  См. TxAuthAdmin#GetTempLogin
     *
     * @deprecated
     * @generated from protobuf rpc: TempLogin(grpc.txauth.TempLoginRequest) returns (grpc.txauth.TempLoginResponse);
     */

  }, {
    key: "tempLogin",
    value: function tempLogin(input, options) {
      var method = this.methods[5],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * deprecated, см. GetOneTimeToken
     *
     * @deprecated
     * @generated from protobuf rpc: OneTimeToken(grpc.txauth.GetOneTimeTokenRequest) returns (grpc.txauth.GetOneTimeTokenResponse);
     */

  }, {
    key: "oneTimeToken",
    value: function oneTimeToken(input, options) {
      var method = this.methods[6],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * *
     *  POST /grpc-json/txauth/v3/getonetimetoken
     *  см. https://wiki.finam.ru/pages/viewpage.action?pageId=303570863
     *
     * @generated from protobuf rpc: GetOneTimeToken(grpc.txauth.GetOneTimeTokenRequest) returns (grpc.txauth.GetOneTimeTokenResponse);
     */

  }, {
    key: "getOneTimeToken",
    value: function getOneTimeToken(input, options) {
      var method = this.methods[7],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     * POST /grpc-json/txauth/v3/exchangeonetimetoken
     *
     * В теле запроса передается:
     * - string ott token
     *
     * @generated from protobuf rpc: ExchangeOneTimeToken(grpc.txauth.ExchangeOneTimeTokenRequest) returns (grpc.txauth.ExchangeOneTimeTokenResponse);
     */

  }, {
    key: "exchangeOneTimeToken",
    value: function exchangeOneTimeToken(input, options) {
      var method = this.methods[8],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     *
     * GET /grpc-json/txauth/v3/autologin?route={..}
     *
     * @generated from protobuf rpc: GetAutologinUrl(grpc.txauth.AutologinRequest) returns (grpc.txauth.AutologinResponse);
     */

  }, {
    key: "getAutologinUrl",
    value: function getAutologinUrl(input, options) {
      var method = this.methods[9],
          opt = this._transport.mergeOptions(options);

      return stackIntercept("unary", this._transport, method, opt, input);
    }
  }]);

  return TxAuthApiClient;
}();